import React from "react";
import { MessagePartInputExtended } from "@/pages/BulkMessaging/types";
import { PhonePreview } from "../PhoneFrame/PhonePreview";
import { ReadOnlyMessageBubble } from "./ReadOnlyMessageBubble";
import { useFilteredMessageParts } from "./hooks/useFilteredMessageParts";

interface MessagePreviewProps {
  messageParts: MessagePartInputExtended[];
  className?: string;
  showStatusBar?: boolean;
  showHomeIndicator?: boolean;
  contentClassName?: string;
  frameClassName?: string;
  senderName?: string;
  senderProfilePhoto?: { url?: string | null } | null;
}

export const MessagePreview = ({
  messageParts,
  className,
  showStatusBar = true,
  showHomeIndicator = true,
  contentClassName,
  frameClassName,
  senderName,
  senderProfilePhoto,
}: MessagePreviewProps) => {
  const { filteredMessageParts } = useFilteredMessageParts(messageParts);

  return (
    <div data-testid="readonly-phone-preview">
      <PhonePreview
        className={className}
        showStatusBar={showStatusBar}
        showHomeIndicator={showHomeIndicator}
        contentClassName={`${contentClassName} pb-6`}
        frameClassName={frameClassName}
      >
        <div className="space-y-3">
          {filteredMessageParts.map((messagePart, index) => (
            <ReadOnlyMessageBubble
              key={`${index}`}
              messagePart={messagePart}
              senderName={senderName}
              senderProfilePhoto={senderProfilePhoto}
            />
          ))}
        </div>
      </PhonePreview>
    </div>
  );
};
